import { render, staticRenderFns } from "./FOtherBanner.vue?vue&type=template&id=04375ea1&scoped=true&"
import script from "./FOtherBanner.vue?vue&type=script&lang=js&"
export * from "./FOtherBanner.vue?vue&type=script&lang=js&"
import style0 from "./FOtherBanner.vue?vue&type=style&index=0&id=04375ea1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04375ea1",
  null
  
)

export default component.exports